/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Terms_TitleInputs */

const da_legal_terms_title = /** @type {(inputs: Legal_Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handelsbetingelser`)
};

/** @type {(inputs: Legal_Terms_TitleInputs) => LocalizedString} */
const en_legal_terms_title = da_legal_terms_title;

/**

* @param {Legal_Terms_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_terms_title = /** @type {((inputs?: Legal_Terms_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Terms_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_terms_title(inputs)
	return /** @type {LocalizedString} */ ("Handelsbetingelser")
});